// Zweite, überarbeitete Version des Lebenslauf-Inhalts (siehe Feedback-Runde).
// Änderungen gegenüber lebenslaufContent.js:
// - Profiltext ersetzt generische Vorlage durch konkrete Positionierung
// - MBS-Bullets von 11 auf 6 verdichtet, nennt Projekte namentlich
// - Neue Sektion "Ausgewählte Projekte" (Jobtracker + Verweis auf Projektübersicht)
// - Skill-Bar "Java" runtergeregelt, "AWS/Azure" und "DevOps" in ehrlichere Einzelwerte aufgeteilt

const lebenslaufContentV2 = {
  de: {
    ui: {
      back: '← Zurück zur Übersicht',
      langLabel: 'CV-Sprache',
      showPhoto: 'Foto anzeigen',
      hidePhoto: 'Foto ausblenden',
      downloadPdf: 'PDF herunterladen',
      downloadingPdf: 'Erstelle PDF...',
      downloadImage: 'Bild herunterladen',
      downloadingImage: 'Erstelle Bild...',
      errorPdf: 'Fehler beim Erstellen der PDF',
      errorImage: 'Fehler beim Erstellen des Bildes',
      addressBerlin: 'Berlin',
      addressNuremberg: 'Nürnberg',
    },
    name: 'Emin Tavli',
    title: 'Fullstack Developer',
    summary:
      'Fullstack-Entwickler mit vier Jahren Erfahrung an der Schnittstelle aus Webentwicklung und IT-Administration. Ich baue eigenständig Tools wie den BAUHAUS QR-Generator und das Modeltool und verwalte produktive Serverumgebungen. Aktuell vertiefe ich mein Profil Richtung Cloud, unter anderem mit den Azure-Zertifizierungen AZ-900, AZ-204, AI-900 und AZ-400.',
    sections: {
      contact: 'Kontakt',
      skills: 'Technische Skills',
      languages: 'Sprachen',
      experience: 'Beruflicher Werdegang',
      projects: 'Ausgewählte Projekte',
      education: 'Akademischer Werdegang',
      additional: 'Weitere Informationen',
      schoolEducation: 'Schulische Ausbildung',
      earlyExperience: 'Frühe Berufserfahrungen',
    },
    birthDate: 'Geburtsdatum: 26.07.1992',
    present: 'heute',
    languages: [
      { name: 'Deutsch', level: 'C2' },
      { name: 'Englisch', level: 'C2' },
      { name: 'Türkisch', level: 'C2' },
      { name: 'Spanisch', level: 'B1' },
    ],
    experience: [
      {
        role: 'Fullstack-Entwickler',
        company: 'MBS Nürnberg',
        duration: '05/2021 - 03/2026',
        bullets: [
          'Konzeption und Entwicklung des BAUHAUS QR-Tools (Custom WordPress-Plugin): Filialmitarbeiter:innen erstellen QR-Codes für Angebote selbstständig, ohne Entwickler-Einbindung',
          'Aufbau des Modeltools (React + Express.js) mit automatisiertem Web-Crawling, Datenbank-Integration und PDF-Export für die Buchungsverwaltung von Models',
          'Anbindung und Pflege von JTL-Shop-Schnittstellen für unternehmensweite E-Commerce-Prozesse',
          'Entwicklung und Wartung unternehmenskritischer Webanwendungen mit TYPO3, WordPress, React, Laravel und Vue.js sowie technische Führung im Projektteam',
          'IT-Administration: Benutzerkonten, Berechtigungen und Gruppenrichtlinien im Active Directory, Einrichtung neuer Arbeitsplätze und Pflege der internen IT-Infrastruktur',
          'Serveradministration (Plesk) und Hosting-Betrieb für alle Unternehmenswebsites, inkl. Updates, Backups und Bereitstellung interner Tools wie Ticketsystem und Arbeitszeittracker',
        ],
      },
      {
        role: 'Selbstständiger Webentwickler',
        company: 'Eigenes Gewerbe',
        duration: '01/2020 - heute',
        bullets: [
          'Entwicklung von maßgeschneiderten Webseiten und Online-Shops für Kunden',
          'Spezialisierung auf WooCommerce und WordPress-basierte Lösungen',
          'Beratung und Implementierung von E-Commerce-Strategien',
          'Wartung und Optimierung bestehender Webprojekte',
        ],
      },
      {
        role: 'Werkstudent Webentwicklung',
        company: 'Arzte.de',
        duration: '01/2019 - 10/2020',
        bullets: [
          'Frontend-Entwicklung mit React.js',
          'Implementierung responsiver Designs',
          'Optimierung der Website-Performance',
          'Zusammenarbeit in agilen Entwicklungsteam',
        ],
      },
      {
        role: 'Praktikum & Werkstudent',
        company: 'IT-Labs',
        duration: '08/2018 - 12/2018',
        bullets: [
          'Erste praktische Erfahrungen in der Webentwicklung und Kennenlernen verschiedener Technologien',
        ],
      },
      {
        role: 'PC-Zusammenbau & Verkauf',
        company: 'K&K Computer',
        duration: '02/2017 - 08/2017',
        bullets: [
          'Zusammenbau von PCs nach Kundenanforderungen',
          'Kundenberatung zu Hardware und PC-Konfigurationen',
          'Verkauf von PC-Teilen und Zubehör',
        ],
      },
    ],
    projects: [
      {
        name: 'Lautbahn (Jobtracker)',
        tech: 'Next.js, TypeScript, KI-Integration',
        bullets: [
          'Eigeninitiative-Projekt: Plattform zur Bewerbungsverwaltung mit KI-gestützter Lebenslauf-Erstellung per Spracheingabe, Job-Tracking und PDF-Export',
          'Live-Link: [LINK EINFÜGEN]',
        ],
      },
      {
        name: 'Modeltool, BAUHAUS QR-Tool & weitere Projekte',
        tech: '',
        bullets: ['Details und Live-Demos: [DEINE-DOMAIN]/bms-projekte'],
      },
    ],
    education: [
      {
        degree: 'Weiterbildung: Azure, DevOps & Security (abgeschlossen)',
        institution: 'Zertifizierungen: AZ-900, AZ-204, AI-900, AZ-400, Security+',
        duration: '03/2026 - 08/2026',
        bullets: [
          'Microsoft Azure Fundamentals (AZ-900) – bestanden',
          'Azure Developer Associate (AZ-204) – bestanden',
          'Azure AI Fundamentals (AI-900) – bestanden',
          'Azure DevOps Engineer Expert (AZ-400) – bestanden',
          'CompTIA Security+ – bestanden',
        ],
      },
      {
        degree: 'Media Engineering (Bachelor of Engineering)',
        institution: 'TH-Nürnberg',
        duration: '10/2014 - 01/2020',
        bullets: [
          'Schwerpunkt: Webentwicklung und Medientechnologie',
          'Bachelorarbeit: "Entwicklung einer skalierbaren Webanwendung mit React.js"',
          'Aktive Teilnahme an Hochschulprojekten',
        ],
      },
      {
        degree: 'Fachoberschule',
        institution: 'Lothar von Faber, Nürnberg',
        duration: '2011 - 2014',
        bullets: ['Abschluss mit Fachhochschulreife, Schwerpunkt Technik'],
      },
    ],
    additional: {
      schoolEducation: [
        '2007 - 2011 Adam-Kraft-Realschule',
        '2005 - 2007 Realschule Lehrte',
        '1999 - 2005 Löwenzahn Grundschule in Berlin',
      ],
      earlyExperience: [
        '2012 Praktikum Prüfungsstelle Arzte Bayern',
        '2011 - 2012 Praktikum Amtsgericht Nürnberg',
        '2009 Kaufmännisches Praktikum',
      ],
    },
  },

  en: {
    ui: {
      back: '← Back to Overview',
      langLabel: 'CV language',
      showPhoto: 'Show photo',
      hidePhoto: 'Hide photo',
      downloadPdf: 'Download PDF',
      downloadingPdf: 'Creating PDF...',
      downloadImage: 'Download Image',
      downloadingImage: 'Creating image...',
      errorPdf: 'Error creating PDF',
      errorImage: 'Error creating image',
      addressBerlin: 'Berlin',
      addressNuremberg: 'Nuremberg',
    },
    name: 'Emin Tavli',
    title: 'Fullstack Developer',
    summary:
      'Fullstack developer with four years of experience at the intersection of web development and IT administration. I build tools like the BAUHAUS QR generator and the Modeltool, and run production server environments. I am currently deepening my profile toward cloud, with the Azure certifications AZ-900, AZ-204, AI-900 and AZ-400.',
    sections: {
      contact: 'Contact',
      skills: 'Technical Skills',
      languages: 'Languages',
      experience: 'Professional Experience',
      projects: 'Selected Projects',
      education: 'Academic Background',
      additional: 'Additional Information',
      schoolEducation: 'School Education',
      earlyExperience: 'Early Work Experience',
    },
    birthDate: 'Date of birth: 26.07.1992',
    present: 'present',
    languages: [
      { name: 'German', level: 'C2' },
      { name: 'English', level: 'C2' },
      { name: 'Turkish', level: 'C2' },
      { name: 'Spanish', level: 'B1' },
    ],
    experience: [
      {
        role: 'Fullstack Developer',
        company: 'MBS Nürnberg',
        duration: '05/2021 - 03/2026',
        bullets: [
          'Designed and built the BAUHAUS QR tool (custom WordPress plugin): branch staff generate QR codes for offers themselves, with no developer involvement',
          'Built the Modeltool (React + Express.js) with automated web crawling, database integration and PDF export for model booking management',
          'Integrated and maintained JTL-Shop interfaces for company-wide e-commerce processes',
          'Developed and maintained business-critical web applications with TYPO3, WordPress, React, Laravel and Vue.js, plus technical leadership within the project team',
          'IT administration: user accounts, permissions and group policies in Active Directory, workstation setup and internal IT infrastructure',
          'Server administration (Plesk) and hosting operations for all company websites, incl. updates, backups and deployment of internal tools such as a ticketing system and time tracker',
        ],
      },
      {
        role: 'Freelance Web Developer',
        company: 'Self-employed',
        duration: '01/2020 - present',
        bullets: [
          'Development of custom websites and online shops for clients',
          'Specialization in WooCommerce and WordPress-based solutions',
          'Consulting on and implementation of e-commerce strategies',
          'Maintenance and optimization of existing web projects',
        ],
      },
      {
        role: 'Working Student, Web Development',
        company: 'Arzte.de',
        duration: '01/2019 - 10/2020',
        bullets: [
          'Frontend development with React.js',
          'Implementation of responsive designs',
          'Website performance optimization',
          'Collaboration within an agile development team',
        ],
      },
      {
        role: 'Internship & Working Student',
        company: 'IT-Labs',
        duration: '08/2018 - 12/2018',
        bullets: [
          'First hands-on experience in web development and exposure to various technologies',
        ],
      },
      {
        role: 'PC Assembly & Sales',
        company: 'K&K Computer',
        duration: '02/2017 - 08/2017',
        bullets: [
          'Assembling PCs to customer specifications',
          'Customer consulting on hardware and PC configurations',
          'Sales of PC components and accessories',
        ],
      },
    ],
    projects: [
      {
        name: 'Lautbahn (Jobtracker)',
        tech: 'Next.js, TypeScript, AI integration',
        bullets: [
          'Self-initiated project: job application platform with AI-assisted CV drafting by voice, job tracking, and PDF export',
          'Live link: [ADD LINK]',
        ],
      },
      {
        name: 'Modeltool, BAUHAUS QR Tool & more',
        tech: '',
        bullets: ['Details and live demos: [YOUR-DOMAIN]/bms-projekte'],
      },
    ],
    education: [
      {
        degree: 'Further Training: Azure, DevOps & Security (completed)',
        institution: 'Certifications: AZ-900, AZ-204, AI-900, AZ-400, Security+',
        duration: '03/2026 - 08/2026',
        bullets: [
          'Microsoft Azure Fundamentals (AZ-900) – passed',
          'Azure Developer Associate (AZ-204) – passed',
          'Azure AI Fundamentals (AI-900) – passed',
          'Azure DevOps Engineer Expert (AZ-400) – passed',
          'CompTIA Security+ – passed',
        ],
      },
      {
        degree: 'Media Engineering (Bachelor of Engineering)',
        institution: 'TH Nürnberg',
        duration: '10/2014 - 01/2020',
        bullets: [
          'Focus: web development and media technology',
          'Bachelor’s thesis: "Development of a Scalable Web Application with React.js"',
          'Active participation in university projects',
        ],
      },
      {
        degree: 'Fachoberschule (Technical Secondary School)',
        institution: 'Lothar von Faber, Nürnberg',
        duration: '2011 - 2014',
        bullets: [
          'Graduated with Fachhochschulreife (technical college entrance qualification), focus on technology',
        ],
      },
    ],
    additional: {
      schoolEducation: [
        '2007 - 2011 Adam-Kraft-Realschule',
        '2005 - 2007 Realschule Lehrte',
        '1999 - 2005 Löwenzahn Grundschule, Berlin',
      ],
      earlyExperience: [
        '2012 Internship, Physicians’ Examination Board Bavaria',
        '2011 - 2012 Internship, Nuremberg Local Court',
        '2009 Business/administrative internship',
      ],
    },
  },
};

export default lebenslaufContentV2;
